import { render, staticRenderFns } from "./test.vue?vue&type=template&id=5b686b5a&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=5b686b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b686b5a",
  null
  
)

export default component.exports